import React from 'react';

import WarningModal from 'ub/components/WarningModal';
import banzai from 'ub/control/banzai-features';

import styles from './UnsupportedFileUploadModal.scss';

export default function UnsupportedFileUploadModal({ fileCount, unsupportedFilenames, onClose }) {
  if (unsupportedFilenames.length === 0) {
    return null;
  }

  const title =
    fileCount > 1
      ? `${fileCount > unsupportedFilenames.length ? 'Some of the' : 'The'} files you tried to ` +
        "upload aren't supported"
      : "The file you tried to upload isn't supported";

  return (
    <WarningModal onClose={onClose} title={title}>
      <div>
        <ul className={styles.fileList}>
          {unsupportedFilenames.map(file => <li key={file}>{file}</li>)}
        </ul>

        <p>
          You can drag and drop the following files into the canvas:<br />
          <strong>JPEG, GIF, PNG, BMP{banzai.features.isSvgUploadEnabled() ? ', SVG' : ''}</strong>.
        </p>
      </div>
    </WarningModal>
  );
}

UnsupportedFileUploadModal.propTypes = {
  fileCount: React.PropTypes.number.isRequired,
  unsupportedFilenames: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,
  onClose: React.PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/UnsupportedFileUploadModal.jsx